import { Heading1 } from "@/components/podkit/typography/Headings";
import { Text } from "@/components/podkit/typography/Text";
import type { FC, ReactNode } from "react";

type AutomationsPageHeaderProps = {
    actions?: ReactNode;
};

export const AutomationsPageHeader: FC<AutomationsPageHeaderProps> = ({ actions }) => {
    return (
        <div className="flex items-start justify-between">
            <div className="flex flex-col">
                <Heading1>Automations</Heading1>
                <Text className="text-base text-content-base">
                    Run parallel Automations across projects with Ona to automate, track, and report at scale.
                </Text>
            </div>
            {actions}
        </div>
    );
};
